import {Injectable} from "@angular/core";
import {DirectoryServiceProxy} from "./directory.service.proxy";
import {Observable} from "rxjs";
import {IDirectoryService} from "../interfaces/directory.service";

@Injectable()
export class DirectoryServiceService {
	constructor(private proxy: DirectoryServiceProxy) { }

	public getDirectoryServices(): Observable<IDirectoryService[]> {
		return this.proxy.getDirectoryServices();
	}
}
